module.exports = __webpack_public_path__ + "img/logo-2.5c9f8ffa.png";